// extracted by mini-css-extract-plugin
export const container = "personal-module--container--30Wgn";
export const cardContainer = "personal-module--cardContainer--3p2AU";
export const innerContainer = "personal-module--innerContainer--1eFOb";
export const inputContainer = "personal-module--inputContainer--11VDX";
export const inputBox = "personal-module--inputBox--Mw_YM";
export const inputBoxHigh = "personal-module--inputBoxHigh--3pose";
export const crewDescription = "personal-module--crewDescription--3_RuV";
export const crewContainer = "personal-module--crewContainer--36urv";
export const inputRow = "personal-module--inputRow--1d-XQ";
export const crewInnerContainer = "personal-module--crewInnerContainer--3sxuK";
export const complete = "personal-module--complete--3nUIG";
export const terms = "personal-module--terms--3Nlbt";
export const inputCheck = "personal-module--inputCheck--uxwDs";